<template>
  <div>
    <i-input v-model="figure" @on-keyup="setHHZToManual">
      <i-select
        v-model="type"
        slot="append"
        style="width: 180px;"
        :class="{ 'not-found-error': isNotFound }"
        @on-change="checkForLookup"
      >
        <i-option value="Manual">Manual</i-option>
        <i-option value="Lookup">Lookup</i-option>
        <i-option value="Not Found">Not Found</i-option>
      </i-select>
    </i-input>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    value: Object,
    conditions: Object,
    recalculate: Boolean,
  },
  data() {
    return {
      type: "Not Found",
      figure: null,
    };
  },
  watch: {
    value() {
      if (this.value !== null) {
        this.type = this.value.type;
        this.figure = this.value.figure;
      }
    },
    conditions() {
      this.checkForLookup();
    },
    recalculate(value) {
      if (value && this.isValidCondition) {
        this.fetchHouseholdSize();
      }
    },
  },
  computed: {
    isNotFound() {
      return this.type === "Not Found";
    },
    isValidCondition() {
      return this.conditions.iso3 !== "" && this.conditions.year > null;
    },
    householdSize() {
      return {
        type: this.type,
        figure: this.figure,
      };
    },
  },
  mounted() {
    if (this.figure === null && this.type !== "Manual") {
      this.checkForLookup();
    }
  },
  methods: {
    // trigger lookup if the HHZ change to Lookup
    checkForLookup() {
      if (this.type === "Lookup" || this.type === "Not Found") {
        this.fetchHouseholdSize();
      }
    },

    // Set HHZ type to manual when the user type in the text input
    setHHZToManual() {
      this.type = "Manual";
      this.$emit("input", this.householdSize);
      this.$emit("change");
    },

    // fetch HHZ value from the database
    fetchHouseholdSize() {
      if (this.isValidCondition && this.type !== "Manual") {
        axios
          .get("/psql/household_sizes", {
            params: {
              iso3: "eq." + this.conditions.iso3,
              year: "eq." + this.conditions.year,
            },
            headers: {
              Accept: "application/vnd.pgrst.object+json",
            },
          })
          .then(response => {
            this.figure = response.data.size;
            this.type = "Lookup";
            this.$emit("input", this.householdSize);
            this.$emit("change");
          })
          .catch(error => {
            this.figure = 0;
            this.type = "Not Found";
            this.$emit("input", this.householdSize);
            this.$emit("change");
            console.error(error);
          });
      }
    },
  },
};
</script>

<style lang="css">
.not-found-error {
  background-color: #dd0000;
  color: white;
  font-weight: bold;
}
.not-found-error i.ivu-icon.ivu-icon-arrow-down-b.ivu-select-arrow {
  color: white;
}
</style>
